import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/Showcase.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
